// Polyfills for older browsers - must be first
import "react-app-polyfill/stable";
import "core-js/stable";

import "bootstrap/dist/css/bootstrap.min.css";

import React from "react";
import { createRoot } from "react-dom/client";
import "./browser-normalize.css"; // Import browser normalization first
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
